import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { API_BASE } from '../../config';

export default function UnsubscribePage() {
  const [searchParams] = useSearchParams();
  const [state, setState] = useState({ loading: true, error: null, done: false });

  useEffect(() => {
    let cancelled = false;
    const token = String(searchParams.get('token') || '').trim();
    if (!token) {
      setState({ loading: false, error: 'Missing unsubscribe token.', done: false });
      return undefined;
    }

    const run = async () => {
      try {
        const res = await fetch(`${API_BASE}/notifications/unsubscribe`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token })
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          throw new Error(data?.error || 'Failed to unsubscribe.');
        }
        if (!cancelled) {
          setState({ loading: false, error: null, done: true });
        }
      } catch (error) {
        if (!cancelled) {
          setState({ loading: false, error: error?.message || 'Failed to unsubscribe.', done: false });
        }
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [searchParams]);

  return (
    <div className="max-w-xl mx-auto px-4 py-16">
      <div className="bg-white border border-gray-200 rounded-2xl shadow-sm p-8">
        <h1 className="text-2xl font-black text-gray-900 mb-4">Email preferences</h1>
        {state.loading ? (
          <p className="text-gray-600">Updating your preferences…</p>
        ) : null}
        {!state.loading && state.done ? (
          <p className="text-gray-700">
            You have been unsubscribed from these emails.
          </p>
        ) : null}
        {!state.loading && state.error ? (
          <p className="text-red-600">{state.error}</p>
        ) : null}
      </div>
    </div>
  );
}
